import { commonMessages } from '@/__scripts/common.messages';
import LinkIcon from '@/assets/icons/link.svg?react';
import { T } from '@/components/i18n/message.i18n.component';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion/accordion.component';
import Button from '@/components/ui/button/button.component';
import { Information } from '@/gql/graphql';
import { pretailoringPageMessages } from '@/pages/products/pre-tailoring/pre-tailoring.messages';
import { useIntl } from 'react-intl';
import { BuildingBlockDetailsRow } from '../building-blocks/details-building-block/details-building-block.component';

type Props = {
  testIdContext: string;
  data: Information[];
};

export const InformationAccordion = ({ data, testIdContext }: Props) => {
  const t = useIntl();

  return data?.map((info) => (
    <Accordion key={info.id} type="single" collapsible className="w-full flex flex-col gap-y-2">
      <AccordionItem
        value={info.id}
        className="border rounded border-other-stroke p-4 flex flex-col justify-between items-center"
      >
        <div className="flex flex-row justify-between items-center w-full h-full">
          <p data-testid={`${testIdContext}-details-information-${info.id}-linkText`} className="typo-primary-500">
            {info.linkText}
          </p>
          <div className="flex flex-row justify-between items-center gap-x-6">
            <Button
              data-testid={`${testIdContext}-details-information-${info.id}-link`}
              variant="secondary"
              className="flex flex-row justify-center items-center"
              onClick={() => {
                window.open(info.link || '', '_blank');
              }}
            >
              <LinkIcon role="img" aria-label="buidling block link icon" className="mr-2" />
              {t.formatMessage(pretailoringPageMessages.openLink)}
            </Button>
            <AccordionTrigger data-testid={`${testIdContext}-details-information-${info.id}-trigger`} />
          </div>
        </div>
        <AccordionContent
          className="flex justify-start items-start w-full"
          data-testid={`${testIdContext}-details-information-${info.id}-content`}
        >
          <BuildingBlockDetailsRow
            context="information-details"
            label={<T {...pretailoringPageMessages.singleBuildingBlockDataBlockDescription} />}
            value={
              <div
                className="flex flex-row gap-2"
                data-testid={`${testIdContext}-details-information-${info.id}-information-details`}
              >
                {info.description ? info.description : <T {...commonMessages.noInfo} />}
              </div>
            }
          />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  ));
};
